import TravelAndParkingCommon from './TravelAndParkingCommon/TravelAndParkingCommon'
import TravelAndParkingSpecific from './TravelAndParkingSpecific/TravelAndParkingSpecific'

export default function TravelAndParking ({ race, distance }) {
  const { travelAndParking } = race?.raceDistances?.find(d => d.distance === distance) || {}

  return (
    <>
      {race?.travelAndParking && <TravelAndParkingCommon />}
      {travelAndParking &&
        <TravelAndParkingSpecific {...{ travelAndParking, race, distance }} />}
    </>
  )
}
